export default "__VITE_ASSET__2f8b9dc7__"